import { PiContextualSuggestionsOnboardingType } from "@webapp/platform-intelligence/shared/components/pi-contextual-suggestion-button/services/pi-contextual-suggestions-onboarding.service";

export const SUGGESTION_STATE_INDICATOR_ONBOARDING_MAX_VIEWS = 3;
export const SUGGESTION_STATE_INDICATOR_ONBOARDING_TOTAL_STEPS = 1;
export const SUGGESTION_STATE_INDICATOR_ONBOARDING_STARTING_STEP = 1;

export type SuggestionStateIndicatorOnboardingType = "suggestionStateIndicatorDefault" | PiContextualSuggestionsOnboardingType;
